/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriAxiosPost } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import CopiriLoader from '../../common/CopiriLoader'; // eslint-disable-next-line
import LodgeHistoryModal from './LodgeHistoryModal'; // eslint-disable-next-line
import LodgeContentModal from './LodgeContentModal'; // eslint-disable-next-line
import LodgeAddressModal from '../LodgeAddressModal'; // eslint-disable-next-line
const LodgeContactSection = props => {
	// eslint-disable-next-line
	const { lodgeData, pageLanguageContent, updateLodgeModal, updateModalMap } = props;
	const [showHideHistoryModal, setShowHideHistoryModal] = useState(false);
	const [showHideContentModal, setShowHideContentModal] = useState(false);
	const [showHideAddressModal, setShowHideAddressModal] = useState(false);
	const [contentType, setContentType] = useState('');
	const [headerLabel, setHeaderLabel] = useState('');
	const [historyText, setHistoryText] = useState('');
	const [id, setId] = useState('');
	useEffect(() => {
		if (lodgeData['id']) {
		}
		// eslint-disable-next-line
	}, [lodgeData['id']]);

	/* show lodge history modal */
	const openLodgeModal = text => {
		setHistoryText(text);
		setShowHideHistoryModal(true);
	};
	/* close lodge history modal */
	const closeHistoryModal = () => {
		setShowHideHistoryModal(false);
	};
	/* open lodge content modal */
	const openLodgeContentModal = (text, type) => {
		setId(lodgeData['id']);
		setHeaderLabel(text);
		setContentType(type);
		setShowHideContentModal(true);
	};
	/* close lodge content modal */
	const closeLodgeContentModal = () => {
		setShowHideContentModal(false);
	};

	/* function to show lodge address modal */
	const openLodgeAddressModal = () => {
		setId(lodgeData['id']);
		setShowHideAddressModal(true);
	};
	/* function to hide lodge address modal */
	const closeLodgeAddressModal = () => {
		setShowHideAddressModal(false);
	};

	const updateLodgeMap = () => {
		updateModalMap();
	};

	return (
		<>
			<Row className='lodge-social-links'>
				<Col lg={12} className='mt-2'>
					<h4>{pageLanguageContent['CLD170'] ? pageLanguageContent['CLD170'] : ''}</h4>
					<hr />
				</Col>
			</Row>
			<Row className='lodge-social-links'>
				<Col lg={6}>
					<Row className='d-flex'>
						<Col xs={2}>
							<h6 className='mb-0 mt-1'>{pageLanguageContent['CLD028'] ? pageLanguageContent['CLD028'] : ''}:</h6>
						</Col>
						<Col xs={7} className='lodge_address_span' id='lodgeModalAddressField'>
							{lodgeData['address'] && lodgeData['address'].length > 0 && (
								<p className='mb-0'> {lodgeData['address'].join(', ')}</p>
							)}
						</Col>
						<Col xs={3} className='text-right'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 badge badge-soft-info'>
									<i className='far fa-edit' onClick={() => openLodgeAddressModal()}></i>
								</Badge>
								{lodgeData['address'] ? (
									<Badge bg={''} className='mr-1 badge badge-soft-info' onClick={() => openLodgeModal('address')}>
										<i className='fas fa-eye'></i>
									</Badge>
								) : (
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								)}
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={6}>
					<Row className='d-flex align-items-center'>
						<Col xs={2}>
							<h6 className='mb-0'>{pageLanguageContent['CLD035'] ? pageLanguageContent['CLD035'] : ''}:</h6>
						</Col>
						<Col xs={7} className='d-flex'>
							<span>
								{lodgeData['email'] ? (
									<a href={`mailto:${lodgeData['email']}`} data-toggle='tooltip' title={lodgeData['email']}>
										{lodgeData['email']}
									</a>
								) : pageLanguageContent['CLD040'] ? (
									pageLanguageContent['CLD040']
								) : (
									''
								)}
							</span>
						</Col>
						<Col xs={3} className='text-right'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(pageLanguageContent['CLD140'] ? pageLanguageContent['CLD140'] : '', 'email')
										}
									></i>
								</Badge>
								{lodgeData['email'] ? (
									<Badge bg={''} className='mr-1 badge badge-soft-info' onClick={() => openLodgeModal('email')}>
										<i className='fas fa-eye'></i>
									</Badge>
								) : (
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								)}
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row className='align-items-center lodge-social-links'>
				<Col lg={6}>
					<Row className='d-flex align-items-center'>
						<Col xs={2}>
							<h6 className='mb-0'>{pageLanguageContent['CLD036'] ? pageLanguageContent['CLD036'] : ''}:</h6>
						</Col>
						<Col xs={7} className='d-flex'>
							<span id='user_phone_no'>
								{lodgeData['phone'] ? (
									<a href={`tel:${lodgeData['phone']}`} data-toggle='tooltip' title={lodgeData['phone']}>
										{lodgeData['phone']}
									</a>
								) : pageLanguageContent['CLD040'] ? (
									pageLanguageContent['CLD040']
								) : (
									''
								)}
							</span>
						</Col>
						<Col xs={3} className='text-right'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(pageLanguageContent['CLD141'] ? pageLanguageContent['CLD141'] : '', 'phone')
										}
									></i>
								</Badge>
								{lodgeData['phone'] ? (
									<Badge bg={''} className='mr-1 badge badge-soft-info' onClick={() => openLodgeModal('phone')}>
										<i className='fas fa-eye'></i>
									</Badge>
								) : (
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								)}
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={6}>
					<Row className='d-flex align-items-center'>
						<Col xs={2}>
							<h6 className='mb-0'>{pageLanguageContent['CLD034'] ? pageLanguageContent['CLD034'] : ''}:</h6>
						</Col>
						<Col xs={7} className='d-flex'>
							<span data-toggle='tooltip' title={lodgeData['website']}>
								{lodgeData['website'] ? (
									<a href={lodgeData['website']} target='_blank' rel='noopener noreferrer'>
										{lodgeData['website']}
									</a>
								) : (
									<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
								)}
							</span>
						</Col>
						<Col xs={3} className='text-right'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD139'] ? pageLanguageContent['CLD139'] : '',
												'website'
											)
										}
									></i>
								</Badge>
								{lodgeData['website'] ? (
									<Badge bg={''} className='mr-1 badge badge-soft-info' onClick={() => openLodgeModal('website')}>
										<i className='fas fa-eye'></i>
									</Badge>
								) : (
									<Badge bg={''} className='mr-1 badge badge-soft-secondary'>
										<i className='fas fa-eye'></i>
									</Badge>
								)}
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row>
				<Col lg={12} className='mt-3'>
					<h4>{pageLanguageContent['CLD171'] ? pageLanguageContent['CLD171'] : ''}</h4>
					<hr />
				</Col>
			</Row>
			<Row className='align-items-center lodge-social-links'>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-facebook social-media-icons mr-1'></i>{' '}
							<h6 className='mb-0'> {pageLanguageContent['CLD037'] ? pageLanguageContent['CLD037'] : ''}: </h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['facebook'] ? (
											<>
												{lodgeData['social']['facebook_link'] ? (
													<>
														<a
															href={lodgeData['social']['facebook']}
															target='_blank'
															rel='noopener noreferrer'
															data-toggle='tooltip'
															title={lodgeData['social']['facebook']}
														>
															{lodgeData['social']['facebook']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['facebook']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD142'] ? pageLanguageContent['CLD142'] : '',
												'facebook'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>

				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-instagram social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD038'] ? pageLanguageContent['CLD038'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['instagram'] ? (
											<>
												{lodgeData['social']['instagram_link'] ? (
													<>
														<a
															href={lodgeData['social']['instagram']}
															data-toggle='tooltip'
															title={lodgeData['social']['instagram']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['instagram']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['instagram']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge
									bg={''}
									className='mr-1 mt-1 badge badge-soft-info'
									onClick={() =>
										openLodgeContentModal(
											pageLanguageContent['CLD142'] ? pageLanguageContent['CLD142'] : '',
											'instagram'
										)
									}
								>
									<i className='far fa-edit'></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-x-twitter social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD039'] ? pageLanguageContent['CLD039'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['twitter'] ? (
											<>
												{lodgeData['social']['twitter_link'] ? (
													<>
														<a
															href={lodgeData['social']['twitter']}
															data-toggle='tooltip'
															title={lodgeData['social']['twitter']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['twitter']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['twitter']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD142'] ? pageLanguageContent['CLD142'] : '',
												'twitter'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-linkedin-in social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD152'] ? pageLanguageContent['CLD152'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['linkedin'] ? (
											<>
												{lodgeData['social']['linkedin_link'] ? (
													<>
														<a
															href={lodgeData['social']['linkedin']}
															data-toggle='tooltip'
															title={lodgeData['social']['linkedin']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['linkedin']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['linkedin']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD142'] ? pageLanguageContent['CLD142'] : '',
												'linkedin'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-tiktok social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD161'] ? pageLanguageContent['CLD161'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['tiktok'] ? (
											<>
												{lodgeData['social']['tiktok_link'] ? (
													<>
														<a
															href={lodgeData['social']['tiktok']}
															data-toggle='tooltip'
															title={lodgeData['social']['tiktok']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['tiktok']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['tiktok']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD161'] ? pageLanguageContent['CLD161'] : '',
												'tiktok'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-threads social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD159'] ? pageLanguageContent['CLD159'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['threads'] ? (
											<>
												{lodgeData['social']['threads_link'] ? (
													<>
														<a
															href={lodgeData['social']['threads']}
															data-toggle='tooltip'
															title={lodgeData['social']['threads']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['threads']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['threads']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD159'] ? pageLanguageContent['CLD159'] : '',
												'threads'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={4}>
					<Row className='d-flex align-items-center'>
						<Col xs={4}>
							<i className='fab fa-bluesky social-media-icons mr-1'></i>
							<h6 className='mb-0'>{pageLanguageContent['CLD160'] ? pageLanguageContent['CLD160'] : ''}:</h6>
						</Col>
						<Col xs={4} className='d-flex'>
							<span>
								{lodgeData['social'] && (
									<>
										{lodgeData['social']['bluesky'] ? (
											<>
												{lodgeData['social']['bluesky_link'] ? (
													<>
														<a
															href={lodgeData['social']['bluesky']}
															data-toggle='tooltip'
															title={lodgeData['social']['bluesky']}
															target='_blank'
															rel='noopener noreferrer'
														>
															{lodgeData['social']['bluesky']}
														</a>
													</>
												) : (
													<>{lodgeData['social']['bluesky']}</>
												)}
											</>
										) : (
											<>{pageLanguageContent['CLD040'] ? pageLanguageContent['CLD040'] : ''}</>
										)}
									</>
								)}
							</span>
						</Col>
						<Col xs={4} className='text-left'>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-info'>
									<i
										className='far fa-edit'
										onClick={() =>
											openLodgeContentModal(
												pageLanguageContent['CLD160'] ? pageLanguageContent['CLD160'] : '',
												'bluesky'
											)
										}
									></i>
								</Badge>
								<Badge bg={''} className='mr-1 mt-1 badge badge-soft-secondary'>
									<i className='fas fa-eye'></i>
								</Badge>
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
			<LodgeHistoryModal
				lodgeData={lodgeData}
				showHideHistoryModal={showHideHistoryModal}
				closeHistoryModal={closeHistoryModal}
				updateLodgeModal={updateLodgeModal}
				historyText={historyText}
			/>

			<LodgeContentModal
				showHide={showHideContentModal}
				closeModal={closeLodgeContentModal}
				id={id}
				headerLabel={headerLabel}
				contentType={contentType}
				lodgeData={lodgeData}
				updateLodgeModal={updateLodgeModal}
			/>

			<LodgeAddressModal
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				id={id}
				showHide={showHideAddressModal}
				closeModal={closeLodgeAddressModal}
				updateLodgeModal={updateLodgeModal}
				closeLodgeAddressModal={closeLodgeAddressModal}
				updateLodgeMap={updateLodgeMap}
			/>
		</>
	);
};
export default LodgeContactSection;
